// extracted by mini-css-extract-plugin
export default {"root":"interests-module___root___b5c9aee3","section":"interests-module___section___a49d2be2","loading":"interests-module___loading___ada34233"};